import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DealService } from '../../../deals/services';
import { MarketingService } from '../../services/marketing.service';
import { MatDialog } from '@angular/material/dialog';
import { CreateEditCampaignComponent } from '../create-edit-campaign/create-edit-campaign.component';
import { MatTableDataSource } from '@angular/material/table';
import { MarketingItemDto, MarketingTableDto } from '../../interafaces/marketing-dto';

@Component({
  selector: 'app-marketing',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.scss']
})
export class MarketingComponent implements OnInit {

  dataSource: MatTableDataSource<MarketingTableDto> = new MatTableDataSource<MarketingTableDto>([]);
  displayedColumns: string[] = ['user', 'deals', 'status', 'lastAction', 'createdBy', 'created', 'actions'];

  constructor(
    private Toastr: ToastrService,
    private dialog: MatDialog,
    private dealService: DealService,
    private marketingService: MarketingService,
  ) { }

  ngOnInit(): void {
    // this.dialog.open(CreateEditCampaignComponent).afterClosed().subscribe(console.log)
    this.marketingService.getAllCampaigns().subscribe({
      next: (campaigns) => {
        this.dataSource.data = campaigns;
      }
    }); 
  }


  createCampaign() {
    this.dialog.open(CreateEditCampaignComponent).afterClosed().subscribe(console.log)
  }

  viewCampaign(campaign: MarketingItemDto) {
    this.dialog.open(CreateEditCampaignComponent, {
      data: {
        campaign
      }
    }).afterClosed().subscribe(console.log)
  }

  editCampaign(campaign: MarketingItemDto) {
    this.dialog.open(CreateEditCampaignComponent, {
      data: campaign,
    }).afterClosed().subscribe(console.log)
  }

  deleteCampaign(campaign: MarketingItemDto) {

  }

}




// export interface MarketingTableDto {
//     id: string;
//     // isDraft: boolean;
//     dealIds: string[];
//     email: string;
//     message: string;
//     status: string;
//     lastAction: string;
//     created: string;
// }

// export interface MarketingItemDto extends MarketingTableDto {
//     emailStatusHistory: EmailStatusHistoryItem[];
//     dealStatusHistory: DealsStatusHistoryItem[];
// }

// export interface EmailStatusHistoryItem {
//     status: string;
//     created: string;
// }

// export interface DealsStatusHistoryItem {
//     dealId: string;
//     projectName: string;
//     status: string;
//     created: string;
// }

// export interface MarketingActionHistoryUpdateDto {
//     description: string;
//     created: string;
// }

// export interface InitiateMarketingDto {
//     id: string | null;
//     email: string;
//     message: string;
//     isDraft: boolean;
//     dealIds: string[];
// }

// // // DTOs
// // export interface IMarketingDto {
// //   id: string;
// //   campaignDescription: string;

// //   targets: IMarketingTarget[],
// //   dealIds: string[];

// //   created?: Date;
// //   publishedOn?: Date;
// // }

// // export interface IMarketingTarget {
// //   firstName: string;
// //   lastName: string;
// //   email: string,
// //   company?: string;
// //   title?: string;
// //   created?: Date;
// // }

// // export interface IMarketingActionDto {
// //   description: string;
// //   created: Date;
// // }